import { clientePedido } from '../../apiClient/index'

const moduloNoticias = {
  namespaced: true,
  state: { },
  actions: {
    
    getNoticiasPublicadas(context, payload) 
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Noticia/FindPublicadas', { params: payload })
      .then(response => resolve(response.data))
      })
    },

    getNoticia(context, payload) {
      return new Promise((resolve)=> {
        clientePedido.get('/api/Noticia/Get', {params: payload})
        .then(response => resolve(response.data))
      })
    },

    uploadImagen(context, payload) {
      
      // armo el payload
      let formData = new FormData()
      formData.append('imagen', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        clientePedido.post(`/api/Noticia/UploadImagen?id=${payload.id}`, formData)
        .then(
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
    },

    saveNoticia(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.post('/api/Noticia/Save', payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
      })
    }
  }
}

export default moduloNoticias